var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 0.710574L20.9569 19.1676C20.9569 19.1676 20.4257 20.4488 18.9649 19.8322L10.2085 13.3542L7.0213 11.8729L1.65953 10.1353C1.65953 10.1353 0.837837 9.85501 0.754837 9.23844C0.671838 8.62187 1.68443 8.29357 1.68443 8.29357L22.9987 0.230131C22.9987 0.222124 24.75 -0.522563 24.75 0.710574Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52807 18.959C9.52807 18.959 9.27077 18.9349 8.95537 17.966C8.63998 16.9972 7.02148 11.8724 7.02148 11.8724L19.8947 3.98515C19.8947 3.98515 20.6417 3.55275 20.6085 3.98515C20.6085 3.98515 20.7413 4.06522 20.3429 4.41755C19.9445 4.77788 10.2336 13.2016 10.2336 13.2016",
    fill: "#D2E4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5616 15.8367L10.1005 18.8875C10.1005 18.8875 9.82663 19.0877 9.53613 18.9596L10.2001 13.2983",
    fill: "#B5CFE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tgIcon.4c1e7e07e7fdd6c85440b735305eba64.svg";
export { ForwardRef as ReactComponent };